import React from 'react'

import ProjectCollectionInStructureModel
    from "../../../../../core/model2/project-collection/project-collection-in-structure-model"
import ProjectTitle from "../../project/project-title/project-title"
import PortfolioTitle from "./portfolio-title"
import ControlShowInProjectsTree from "../../../../../core/gd-app/component/quick-links/aim";

export default function PortfolioHeaderTitle() {

    const goToProject = (projectId:ID):void => {
        gd.navigation.goToProject(projectId)
    }

    const projectCollection = gd.session.projectCollections.get(gd.projectCollectionViews.projectCollectionId)
    if (projectCollection?.isInStructure) {
        const pc        = projectCollection as ProjectCollectionInStructureModel
        const project   = gd.session.projects.get(pc.customViewModel.parentProjectId!)!
        return (
            <>
                <ProjectTitle projectId             = {pc.customViewModel.parentProjectId!} />

                <ControlShowInProjectsTree project={project}/>
            </>
        )
    } else {
        return <PortfolioTitle projectCollectionId={gd.projectCollectionViews.projectCollectionId}/>
    }
}